module.exports = __webpack_public_path__ + "static/media/5120.b57997f0.jpg";